export default {
	documentsContainer: {
		marginBottom: "25px !important"
	},

	document: {
		paddingBottom: "5px",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		borderBottom: "1px solid #acbee8",

		"& button": {
			width: "200px",
			height: "50px",
			color: "#fff",
			fontWeight: "600",
			background: "#7fc2ff",
			borderColor: "#7fc2ff",
			border: "1px solid",
			borderRadius: "5px",
			cursor: "pointer",
			transition: "all .2s ease",

			"&:hover": {
				color: "#465578",
				background: "transparent"
			},

			"@media(max-width: 1024px)": {
				width: "90px",
				height: "37px",
				fontSize: "12px",
				borderRadius: "3px"
			},

			"@media(max-width: 767px)": {
				width: "75px",
				minHeight: "auto !important",
				height: "35px"
			}
		}
	}
}
